<template>
  <div>
    <v-row class="mx-12 mt-n4">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card width="1000" flat class="mt-8">
          <v-row no-gutters>
            <v-col cols="3" class="text-right">
              <v-card color="transparent" flat>
                <v-card-text class="headline primary--text">
                  Account
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3"
              ><v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="dialogPersonal = !dialogPersonal"
                    color="success"
                    class="title ml-n1 mt-5"
                    >mdi-pencil</v-icon
                  ></template
                >
                <span>Edit</span>
              </v-tooltip>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card color="transparent" flat>
                <v-card-text class="headline primary--text">
                  Basic
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="dialogBasic = !dialogBasic"
                    color="success"
                    class="title ml-n1 mt-5"
                    >mdi-pencil</v-icon
                  ></template
                >
                <span>Edit</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text  mt-n6">
                Name:
              </v-card-text>
            </v-col>
            <v-col cols="3"
              ><v-card-text class="subtitle-1 mt-n6">
                {{ profile.title }} {{ profile.firstName }}
                {{ profile.familyName }}
              </v-card-text></v-col
            >
            <v-col cols="3" class="text-right"
              ><v-card-text class="subtitle-1 grey--text  mt-n6">
                Gender:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n6">
                {{ profile.gender }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text  mt-n8">
                Account Name:
              </v-card-text>
            </v-col>
            <v-col cols="3"
              ><v-card-text class="subtitle-1 mt-n8">
                {{ profile.name }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n8">
                Martial status:
              </v-card-text>
            </v-col>
            <v-col cols="3"
              ><v-card-text class="subtitle-1 mt-n8">
                {{ profile.martialStatus }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text  mt-n8">
                Account Type:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.type }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n8">
                Residency status:
              </v-card-text>
            </v-col>
            <v-col cols="3"
              ><v-card-text class="subtitle-1 mt-n8">
                {{ profile.residencyStatus }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3"> </v-col>
            <v-col cols="3" class="text-right"
              ><v-card-text class="subtitle-1 grey--text mt-n8">
                Date of birth:
              </v-card-text>
            </v-col>
            <v-col cols="3"
              ><v-card-text class="subtitle-1  mt-n8">
                {{ profile.birthDate }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"
              ><v-card color="transparent" flat>
                <v-card-text class="headline primary--text mt-3">
                  Address
                </v-card-text>
              </v-card></v-col
            >
            <v-col cols="3"
              ><v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="dialogAddress = !dialogAddress"
                    color="success"
                    class="title ml-n1 mt-8"
                    >mdi-pencil</v-icon
                  ></template
                >
                <span>Edit</span>
              </v-tooltip>
            </v-col>
            <v-col cols="3" class="text-right"
              ><v-card color="transparent" flat>
                <v-card-text class="headline primary--text mt-3">
                  Contact
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3"
              ><v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="dialogContact = !dialogContact"
                    color="success"
                    class="title ml-n1 mt-8"
                    >mdi-pencil</v-icon
                  ></template
                >
                <span>Edit</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right mt-n6">
              <v-card-text class="subtitle-1 grey--text">
                Residential:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n6">
                {{ profile.resNumber }}
                {{ profile.resStreet }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n6">
                Pref. contact:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n6">
                {{ profile.prefContactMethod }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.resSuburb }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n8">
                Email address:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.email }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.resCity }}
                {{ profile.resPostcode }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n8">
                Mobile phone:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.mobilePhone }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.resCountry }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n8">
                Work phone:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.workPhone }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n4">
                Mailing:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n4">
                {{ profile.mailNumber }}
                {{ profile.mailStreet }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n8">
                Home phone:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.homePhone }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.mailSuburb }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-card-text class="subtitle-1 grey--text mt-n12">
                Pref. phone:
              </v-card-text>
            </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n12">
                {{ profile.prefContactNumber }}
              </v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.mailCity }}
                {{ profile.mailPostcode }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3"> </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3">
              <v-card-text class="subtitle-1 mt-n8">
                {{ profile.mailCountry }}
              </v-card-text>
            </v-col>
            <v-col cols="3" class="text-right"> </v-col>
            <v-col cols="3"> </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog persistent v-model="dialogPersonal" width="400px">
      <v-card>
        <v-card-title class="headline ml-3">
          <span class="headline mt-4">Update personal details</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-select
                    v-model="profile.title"
                    :items="titleItems"
                    label="Title"
                  ></v-select>
                </v-col>
                <v-col cols="8"> </v-col>
                <v-col cols="6" class="mt-n5">
                  <v-text-field
                    v-model="profile.firstName"
                    :rules="nameReqRules"
                    label="First name"
                /></v-col>
                <v-col cols="6" class="mt-n5">
                  <v-text-field
                    v-model="profile.familyName"
                    :rules="nameReqRules"
                    label="Family name"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn text class="primary--text" @click="close">Cancel</v-btn>
              <v-btn text color="success" :disabled="!valid" @click="update"
                >Update</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogBasic" width="400px">
      <v-card>
        <v-card-title class="headline ml-3">
          <span class="headline mt-4">Update basic details</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="profile.gender"
                    :items="genderItems"
                    label="Gender"
                  ></v-select>
                  <v-select
                    v-model="profile.martialStatus"
                    :items="martialStatusItems"
                    label="Martial status"
                  ></v-select>
                  <v-select
                    v-model="profile.residencyStatus"
                    :items="residencyStatusItems"
                    label="Residency status"
                  ></v-select>
                  <template>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="profile.birthDate"
                          readonly
                          label="Date of birth"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="profile.birthDate"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn text class="primary--text" @click="close">Cancel</v-btn>
              <v-btn text color="success" :disabled="!valid" @click="update"
                >Update</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogAddress" width="500px">
      <v-card>
        <v-card-title class="headline ml-3">
          <span class="headline mt-4">Update address details</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-card-text class="title ml-n4">
                    Residential
                  </v-card-text></v-col
                >
                <v-col cols="6">
                  <v-card-text class="title ml-n4">
                    Mailing
                  </v-card-text>
                  <v-btn
                    @click="copyResidential"
                    color="success"
                    text
                    small
                    class="mt-n5"
                  >
                    (copy residental)</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="mt-n4">
                  <v-text-field
                    v-model="profile.resNumber"
                    :rules="numberRules"
                    label="Number"
                  />
                  <v-text-field
                    v-model="profile.resStreet"
                    :rules="nameRules"
                    label="Street"
                  />
                  <v-text-field
                    v-model="profile.resSuburb"
                    :rules="nameRules"
                    label="Suburb"
                  />
                  <v-text-field
                    v-model="profile.resCity"
                    :rules="nameRules"
                    label="Town / City"
                  />
                  <v-text-field
                    v-model="profile.resPostcode"
                    :rules="numberRules"
                    label="Postcode"
                  />
                  <v-text-field
                    v-model="profile.resCountry"
                    :rules="nameRules"
                    label="Country"
                  />
                </v-col>
                <v-col cols="6" class="mt-n4">
                  <v-text-field
                    v-model="profile.mailNumber"
                    :rules="numberRules"
                    label="Number"
                  />
                  <v-text-field
                    v-model="profile.mailStreet"
                    :rules="nameRules"
                    label="Street"
                  />
                  <v-text-field
                    v-model="profile.mailSuburb"
                    :rules="nameRules"
                    label="Suburb"
                  />
                  <v-text-field
                    v-model="profile.mailCity"
                    :rules="nameRules"
                    label="Town / City"
                  />
                  <v-text-field
                    v-model="profile.mailPostcode"
                    :rules="numberRules"
                    label="Postcode"
                  />
                  <v-text-field
                    v-model="profile.mailCountry"
                    :rules="nameRules"
                    label="Country"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn text class="primary--text" @click="close">Cancel</v-btn>
              <v-btn text color="success" :disabled="!valid" @click="update"
                >Update</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogContact" width="400px">
      <v-card>
        <v-card-title class="headline ml-3">
          <span class="headline mt-4">Update contact details</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="profile.prefContactMethod"
                    :items="prefContactMethodItems"
                    label="Preferred method of contact"
                    prepend-icon="mdi-account-tie-voice"
                  ></v-select>
                  <v-text-field
                    v-model="profile.email"
                    label="Email"
                    :rules="emailReqRules"
                    prepend-icon="mdi-email"
                  />
                  <v-text-field
                    v-model="profile.mobilePhone"
                    label="Mobile phone"
                    :rules="phoneReqRules"
                    prepend-icon="mdi-phone"
                  />
                  <v-text-field
                    v-model="profile.workPhone"
                    label="Work phone"
                    :rules="phoneRules"
                    prepend-icon="mdi-phone"
                  />
                  <v-text-field
                    v-model="profile.homePhone"
                    label="Home phone"
                    :rules="phoneRules"
                    prepend-icon="mdi-phone"
                  />
                  <v-select
                    v-model="profile.prefContactNumber"
                    :items="prefContactNumberItems"
                    label="Preferred contact number"
                    prepend-icon="mdi-card-account-phone"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn text class="primary--text" @click="close">Cancel</v-btn>
              <v-btn text color="success" :disabled="!valid" @click="update"
                >Update</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { authComputed } from '@/vuex/helpers.js'
import StaticDataService from '@/services/StaticDataService.js'

export default {
  name: 'clientProfilePersonOne',

  data() {
    return {
      menu: false,
      dialogPersonal: false,
      dialogBasic: false,
      dialogAddress: false,
      dialogContact: false,
      valid: true,
      titleItems: ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr'],
      genderItems: StaticDataService.getCategoryGender(),
      prefContactMethodItems: ['Mail', 'Phone', 'Email', 'Falcon9'],
      prefContactNumberItems: ['Mobile phone', 'Work phone', 'Home phone'],
      martialStatusItems: ['Single', 'Married'],
      residencyStatusItems: ['Resident Visa', 'NZ Resident'],
      nameRules: [
        v =>
          !v || (v && v.length <= 20) || 'Name must be less than 20 characters'
      ],
      nameReqRules: [
        v => !!v || 'Field is required',
        v =>
          !v || (v && v.length <= 20) || 'Name must be less than 20 characters'
      ],
      numberRules: [
        v => !v || /^(?=.*\d).+$/.test(v) || 'Requires numbers only'
      ],
      numberRulesCode: [
        v => !!v || 'Code is required',
        v =>
          (/^(?=.*\d).+$/.test(v) && v.length == 6) ||
          'Code must be 6 characters'
      ],
      phoneRules: [
        v => !v || /^[+]+\d+$/.test(v) || 'Use this form ... +64210123456'
      ],
      phoneReqRules: [
        v => !!v || 'Phone is required',
        v => !v || /^[+]+\d+$/.test(v) || 'Use this form ... +64210123456'
      ],
      emailReqRules: [
        v => !!v,
        v => !v || (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid'
      ]
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },

  methods: {
    save(date) {
      this.$refs.menu.save(date)
    },
    copyResidential() {
      this.profile.mailNumber = this.profile.resNumber
      this.profile.mailStreet = this.profile.resStreet
      this.profile.mailSuburb = this.profile.resSuburb
      this.profile.mailCity = this.profile.resCity
      this.profile.mailPostcode = this.profile.resPostcode
      this.profile.mailCountry = this.profile.resCountry
    },
    update() {
      this.$store.dispatch('updateClient', this.clientId).then(() => {
        this.dialogPersonal = false
        this.dialogBasic = false
        this.dialogAddress = false
        this.dialogContact = false
      })
    },
    close() {
      this.$store.dispatch('fetchClient', this.clientId).then(() => {
        this.dialogPersonal = false
        this.dialogBasic = false
        this.dialogAddress = false
        this.dialogContact = false
      })
    }
  },

  computed: {
    profile: {
      get() {
        return this.client.profile
      },
      set(attributes) {
        this.$store.commit('SET_CLIENT_PROFILE', attributes)
      }
    },

    ...mapState(['client', 'system']),

    ...authComputed
  }
}
</script>

<style lang="scss" scoped></style>
